import { Modal } from "antd";
import { MODAL_MASK_STYLE, MODAL_SIZE, MODAL_SIZE_CLASSES } from "constants/ui";

const AmerModal = ({
  isOpen,
  handleCancel,
  title,
  description,
  mainTitle = "",
  subTitle = "",
  size = MODAL_SIZE.LARGE,
  children,
  footer = null,
  allowOverflow = false,
  className = "",
  // Merged with the shell's own `styles` per key, rather than replacing them.
  styles = {},
  ...props
}) => {
  const heading = title ?? subTitle;
  const subHeading = description ?? mainTitle;

  const overflow = allowOverflow ? { overflow: "visible" } : null;
  const modalStyles = {
    ...styles,
    mask: { ...MODAL_MASK_STYLE, ...styles.mask },
    body: { ...overflow, ...styles.body },
    content: { ...overflow, ...styles.content },
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
      className={`amer-pop add-unit ${
        MODAL_SIZE_CLASSES[size] ?? MODAL_SIZE_CLASSES[MODAL_SIZE.LARGE]
      } ${className}`}
      closable={false}
      styles={modalStyles}
      {...props}
    >
      <div className={`amer-pop-header`}>
        <div className="min-w-0">
          {heading && <div className="amer-pop-title">{heading}</div>}
          {subHeading && <div className="amer-pop-subtitle">{subHeading}</div>}
        </div>
        <button
          type="button"
          onClick={handleCancel}
          aria-label="close"
          className="amer-pop-close"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>
      </div>

      <div
        className={`amer-modal-children ${
          allowOverflow ? "overflow-visible" : "overflow-auto"
        }`}
      >
        {children}
      </div>

      {footer && <div className="amer-pop-footer">{footer}</div>}
    </Modal>
  );
};
export default AmerModal;
